(function () {
  'use strict';

  window.showEmptyCollectionPopup = function(customMsg) {
    var overlay = document.createElement('div');
    overlay.className = 'vap-empty-popup-overlay';
    overlay.innerHTML =
      '<div class="vap-empty-popup">' +
        '<div class="vap-empty-popup__header">' +
          '<div class="vap-empty-popup__icon-wrap">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>' +
              '<line x1="3" y1="6" x2="21" y2="6"/>' +
              '<path d="M16 10a4 4 0 0 1-8 0"/>' +
            '</svg>' +
          '</div>' +
        '</div>' +
        '<div class="vap-empty-popup__body">' +
          '<button class="vap-empty-popup__close" aria-label="Close">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
          '<h3 class="vap-empty-popup__title">Coming Soon!</h3>' +
          '<div class="vap-empty-popup__dots"><span></span><span></span><span></span><span></span><span></span></div>' +
          '<p class="vap-empty-popup__msg">' + (customMsg || 'New arrivals are on the way.<br>Products will be available Soon.') + '</p>' +
          '<button class="vap-empty-popup__dismiss">Got it</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { overlay.classList.add('is-visible'); });
    });
    function close() {
      overlay.classList.remove('is-visible');
      setTimeout(function() { if (overlay.parentNode) overlay.remove(); }, 300);
    }
    overlay.querySelector('.vap-empty-popup__close').addEventListener('click', close);
    overlay.querySelector('.vap-empty-popup__dismiss').addEventListener('click', close);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
  }

  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-empty-collection]');
    if (el) { e.preventDefault(); showEmptyCollectionPopup(); return; }

    var link = e.target.closest('a');
    if (link && link.dataset.unavailable !== 'true') {
      var href = link.getAttribute('href');
      if (href === '' || href === null) {
        e.preventDefault();
        showEmptyCollectionPopup();
      }
    }
  });

  var icons = {
    forwardArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.2222 4.67418C11.326 4.67418 9.59778 2.84001 9.59778 0.825825V0H8.04222V0.825825C8.04222 2.29084 8.64733 3.66501 9.597 4.67418H0V6.32583H9.597C8.64733 7.33499 8.04222 8.70916 8.04222 10.1742V11H9.59778V10.1742C9.59778 8.15999 11.326 6.32583 13.2222 6.32583H14V4.67418H13.2222Z" fill="#FEFFFD"/></svg>',
    backwardArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.777778 6.32582C2.674 6.32582 4.40222 8.15999 4.40222 10.1742V11H5.95778V10.1742C5.95778 8.70916 5.35267 7.33499 4.403 6.32582H14V4.67417H4.403C5.35267 3.66501 5.95778 2.29084 5.95778 0.825825V0H4.40222V0.825825C4.40222 2.84001 2.674 4.67417 0.777778 4.67417H0V6.32582H0.777778Z" fill="#FEFFFD"/></svg>'
  };

  function initDynamicSubmenu(submenuOverlaySelector, menuJsonSelector, trigger_node) {
    var submenuOverlay = document.querySelector(submenuOverlaySelector);
    if (!submenuOverlay) return;

    var galleryController = submenuOverlay.querySelector('.gallery-controller');
    var menuJsonEl = document.querySelector(menuJsonSelector);
    var menuJson = menuJsonEl ? menuJsonEl.textContent : null;
    if (!menuJson) return;

    var menuData = JSON.parse(menuJson);

    var open_sub_menu_status = false;
    var menu_swiper = null;
    var closeTimeout;
    var submenuDebounce;

    function findNodeByHandle(menuArray, handle) {
      for (var i = 0; i < menuArray.length; i++) {
        var node = menuArray[i];
        if (node.handle === handle) return node;
        if (node.links) {
          var found = findNodeByHandle(node.links, handle);
          if (found) return found;
        }
      }
      return null;
    }

    function render_submenu(node_data) {
      var headingEl = galleryController.querySelector('.submenu__heading');
      headingEl.innerHTML = node_data.backtrack && node_data.backtrack !== '#'
        ? '<span class="submenu-group-title">' + node_data.title + '</span>' +
          '<span class="icon-heading-container animate-item" data-backtrack="' + node_data.backtrack + '">' +
            '<span class="backtrack-icon">' + icons.backwardArrow + '</span>' +
            '<span class="sub-heading">' + node_data.title + '</span>' +
          '</span>'
        : '<span class="submenu-group-title">' + node_data.title + '</span>';

      var submenu_list = [];
      var submenu_img_card = [];

      node_data.links.forEach(function(ele) {
        if (ele.image_url) {
          submenu_img_card.push(
            '<a href="' + ele.url + '" class="swiper-slide submenu-card animate-item"' + (ele.is_empty ? ' data-empty-collection="true"' : '') + '>' +
              '<div class="image-container img-loading">' +
                '<img src="' + ele.image_url + '" loading="lazy" class="submenu-img">' +
              '</div>' +
              '<div class="submenu-title">' + ele.title + '</div>' +
            '</a>'
          );
        }

        submenu_list.push(ele.links && ele.links.length > 0
          ? '<li class="animate-item"><span class="submenu-link" data-handle="' + ele.handle + '">' +
              '<span class="link submenu__link">' + ele.title + '</span>' +
              '<span class="forwordtrack-icon">' + icons.forwardArrow + '</span>' +
            '</span></li>'
          : '<li class="animate-item"><a href="' + ele.url + '"' + (ele.is_empty ? ' data-empty-collection="true"' : '') + '>' +
              '<span class="link submenu__link">' + ele.title + '</span>' +
            '</a></li>');
      });

      galleryController.querySelector('.gallery-controller__controls').innerHTML = submenu_list.join('');
      galleryController.querySelector('.swiper-wrapper').innerHTML = submenu_img_card.join('');

      galleryController.querySelectorAll('.submenu-img').forEach(function(img, i) {
        img.style.transitionDelay = (i * 0.05) + 's';
        if (img.complete && img.naturalWidth) {
          img.classList.add('loaded');
          var ic = img.closest('.image-container');
          if (ic) ic.classList.remove('img-loading');
        } else {
          img.addEventListener('load', function() {
            img.classList.add('loaded');
            var ic = img.closest('.image-container');
            if (ic) ic.classList.remove('img-loading');
          });
        }
      });

      submenuOverlay.querySelectorAll('.animate-item').forEach(function(el, i) {
        el.style.transitionDelay = Math.min(i * 0.05, 0.3) + 's';
        requestAnimationFrame(function() { el.classList.add('loaded'); });
      });

      var loadingBox = galleryController.querySelector('#submenu-loading-box');
      if (loadingBox) {
        requestAnimationFrame(function() { loadingBox.classList.remove('visible'); });
      }
    }

    function setSubmenuHeight() {
      document.documentElement.style.setProperty('--header-submenu-height', submenuOverlay.offsetHeight + 'px');
    }

    function showSkeleton() {
      clearTimeout(closeTimeout);
      document.querySelector('.header-container').classList.add('active');
      submenuOverlay.classList.add('active');

      var loadingBox = galleryController.querySelector('#submenu-loading-box');
      if (loadingBox) loadingBox.classList.add('visible');

      galleryController.querySelector('.submenu__heading').innerHTML = '';
      galleryController.querySelector('.gallery-controller__controls').innerHTML = '';
      galleryController.querySelector('.swiper-wrapper').innerHTML = '';
    }

    function showSubmenu(handle) {
      clearTimeout(submenuDebounce);
      showSkeleton();
      submenuDebounce = setTimeout(function() {
        open_sub_menu_status = true;
        clearTimeout(closeTimeout);
        document.querySelector('.header-container').classList.add('active');
        submenuOverlay.classList.add('active');
        var node = findNodeByHandle(menuData, handle);
        if (node) render_submenu(node);
        initSubmenuSwiper();
        setSubmenuHeight();
      }, 80);
    }

    function hideSubmenu() {
      open_sub_menu_status = false;
      clearTimeout(submenuDebounce);
      closeTimeout = setTimeout(function() {
        submenuOverlay.classList.remove('active');
        galleryController.querySelector('.gallery-controller__controls').innerHTML = '';
        galleryController.querySelector('.swiper-wrapper').innerHTML = '';
        if (menu_swiper) {
          menu_swiper.destroy(true, true);
          menu_swiper = null;
        }
        document.querySelector('.header-container').classList.remove('active');
      }, 150);
    }

    function initSubmenuSwiper() {
      if (menu_swiper) {
        menu_swiper.destroy(true, true);
        menu_swiper = null;
      }
      function _create() {
        menu_swiper = new Swiper(submenuOverlaySelector + ' #submenu-slider', {
          slidesPerView: 'auto',
          spaceBetween: 20,
          navigation: {
            nextEl: submenuOverlaySelector + ' .custom-swiper-button-next',
            prevEl: submenuOverlaySelector + ' .custom-swiper-button-prev',
          },
        });
      }
      if (typeof Swiper !== 'undefined') { _create(); return; }
      var src = window.__vapSwiperSrc;
      if (!src) return;
      if (!document.querySelector('link[href*="swiper@11.2.10.css"]')) {
        var cssHref = src.replace('swiper@11.2.10.js', 'swiper@11.2.10.css');
        var lnk = document.createElement('link');
        lnk.rel = 'stylesheet';
        lnk.href = cssHref;
        document.head.appendChild(lnk);
      }
      var s = document.createElement('script');
      s.src = src;
      s.onload = _create;
      document.head.appendChild(s);
    }

    var triggerEl = document.querySelector(trigger_node);
    if (triggerEl) {
      triggerEl.addEventListener('mouseenter', function(e) {
        var link = e.target.closest('a');
        if (!link) return;
        if (link.classList.contains('has-child')) {
          showSubmenu(link.dataset.handle);
        } else if (open_sub_menu_status) {
          hideSubmenu();
        }
      }, true);
    }

    submenuOverlay.addEventListener('mouseenter', function() { clearTimeout(closeTimeout); });
    submenuOverlay.addEventListener('mouseleave', hideSubmenu);

    submenuOverlay.addEventListener('click', function(e) {
      var handleEl = e.target.closest('[data-handle]');
      if (handleEl) render_submenu(findNodeByHandle(menuData, handleEl.dataset.handle));
      var backtrack = e.target.closest('[data-backtrack]');
      if (backtrack) render_submenu(findNodeByHandle(menuData, backtrack.dataset.backtrack));
    });

    var sticky_header = document.querySelector('.shopify-section.shopify-section-group-header-group.section-header');
    if (sticky_header) {
      sticky_header.addEventListener('mouseleave', function(e) {
        var rect = sticky_header.getBoundingClientRect();
        if (open_sub_menu_status && e.clientY <= rect.top) hideSubmenu();
      });
    }
  }

  function init() {
    initDynamicSubmenu('.submenuOverlay', '#menu-with-images', '.list-menu.list-menu--inline');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
